import L from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'theme/moydom/less/pages/spravochnik.less';

export class Map {
    private _defaultIcon: L.Icon;

    constructor(
        private element: Element,
        private map: L.Map
    ) {
        this._defaultIcon = L.icon({
            shadowUrl: null,
            iconAnchor: new L.Point(15, 50),
            iconSize: new L.Point(30, 50),
            iconUrl: '/theme/images/map/pin.svg',
        });
    }


    makeSvgIcon(svgIcon: string|null) {
        if (!svgIcon) {
            return this._defaultIcon;
        }

        const iconUrl = 'data:image/svg+xml;base64,' + btoa(svgIcon);

        return L.icon({
            shadowUrl: null,
            iconAnchor: new L.Point(12, 33),
            iconSize: new L.Point(24, 33),
            iconUrl: iconUrl,
        });
    }
    setColorForDefaultSvgIcon(color: string) {
        const svgIcon = `<svg xmlns='http://www.w3.org/2000/svg' width='30' height='50' viewBox='0 0 30 50'><g fill='none' fill-rule='evenodd'><ellipse cx='15' cy='46' fill='#333' opacity='.25' rx='13' ry='4'/><g fill='${color}'><rect width='25' height='25' x='2.498' y='3.143' stroke='#FFF' stroke-width='5' rx='12.5'/><path d='M14.573 45.439c-1.402-.027-2.797-.544-3.906-1.549l-.218-.207-5.806-5.366c-.494-.456-.725-1.13-.617-1.793.18-1.09 1.208-1.828 2.298-1.65 2.505.412 4.988.64 7.448.686l1.124.009c2.761 0 5.551-.232 8.37-.694 1.09-.18 2.118.56 2.297 1.65.109.662-.123 1.336-.616 1.792l-5.806 5.366c-1.142 1.141-2.629 1.727-4.125 1.756h-.443z'/></g></g></svg>`;
        const iconUrl = 'data:image/svg+xml;base64,' + btoa(svgIcon);
        return L.icon({
            shadowUrl: null,
            iconAnchor: new L.Point(22, 49),
            iconSize: new L.Point(40, 49),
            iconUrl,
        });
    }

    set defaultIcon(value: L.Icon) {
        this._defaultIcon = value;
    }

    public addGeoObject(geoObject: object) {
        const geoJson = L.geoJson(geoObject, {
            pointToLayer: (feature, latlng) => {
                this.map.panTo(latlng);
                let icon = null;
                if (feature.properties) {
                    icon = feature?.properties?.style?.color
                        ? this.setColorForDefaultSvgIcon(feature?.properties?.style?.color)
                        : this.makeSvgIcon(feature?.properties?.icon);
                } else {
                    icon = this.makeSvgIcon(null);
                }
                return L.marker(latlng, { icon: icon });
            },
            style: function (layer) {
                return {
                    color: layer.properties['style']['color'],
                    fillColor: layer.properties['style']['color'],
                    opacity: 0.5,
                    fillOpacity: 0.33,
                    weight: 5,
                };
            },
            onEachFeature: (feature, layer) => {
                layer.on('click', () => {
                    // this.config.event.onChoiceElem([JSON.parse(geoObject).properties.id]);
                });
            },
        });

        geoJson.addTo(this.map);
    }

    resizeObserver() {
        const resizeObserver = new ResizeObserver(() => {
            this.map.invalidateSize();
        });

        resizeObserver.observe(this.element);
    }

    refresh() {
        this.map.invalidateSize();
    }
}
